import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import {Location} from '@angular/common';

import {Funcoes} from "../funcoes";
import {Global} from "../global";
import {ObservacoesFichasModel} from "./observacoes-fichas.model";
import {ObservacoesFichasService} from "./observacoes-fichas.service";


@Component({
  selector: 'app-observacoes-fichas-form',
  templateUrl: './observacoes-fichas-form.component.html'
})
export class ObservacoesFichasFormComponent implements OnInit {

  form: FormGroup;
  title: string;
  observacao: ObservacoesFichasModel = new ObservacoesFichasModel();
  pageIsUpd: boolean = false;
  pageIsAdd: boolean = false;
  enviando = false;
  listCores = [];

  constructor(
    formBuilder: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private observacoesFichasService: ObservacoesFichasService,
    private _location: Location,
    public func: Funcoes,
    public global: Global
  ) {
    this.form = formBuilder.group({
      id_observacao: [],
      observacao_pt: ['', [
        Validators.required
      ]],
      observacao_en: ['', [
        Validators.required
      ]],
      observacao_es: ['', [
        Validators.required
      ]],
      cor: [null]
    });

    this.listCores = [{
      "nome": "Verde",
      "valor": 1
    },{
      "nome": "Amarelo",
      "valor": 2
    },{
      "nome": "Vermelho",
      "valor": 0
    }];
  }

  ngOnInit() {

    // verifica se é uma página de edição
    if(this.router.url.split(/\//).pop() == 'upd'){
      this.pageIsUpd = true;
    }

    // verifica se é uma página para adicionar
    if(this.router.url.split(/\//).pop() == 'add'){
      this.pageIsAdd = true;
    }

    let id = this.route.params.subscribe(params => {
      let id = params['id_observacao'];

      if(!this.pageIsUpd){
        this.title = this.func.traduzir('front.editarObservacao');
      }else{
        this.title = id ? this.func.traduzir('front.visualizarObservacao') : this.func.traduzir('front.cadastrarNovaObservacao');
      }

      if (!id) {
        return;
      }

      this.observacoesFichasService.getById(id)
        .subscribe(
          json => {
            if(this.pageIsUpd) {
              this.title = this.func.traduzir('front.editarObservacao')+': '+json.Payload[0].observacao_pt;
            }else{
              this.title = this.func.traduzir('front.visualizarObservacao') + ': ' + json.Payload[0].observacao_pt;
            }
            this.observacao = json.Payload[0];

            if(this.global.debug == true){
              console.log(json.Payload[0]);
            }
          },
          error => {
            this.func.showErro(error.json());
          });
    });
  }

  voltar() {
    this._location.back();
  }

  save() {
    this.enviando = true;
    let result,
      values = this.form.value;

    if (values.id_observacao) {
      result = this.observacoesFichasService.editar(values, values.id_observacao);
    } else {
      result = this.observacoesFichasService.adicionar(values);
    }

    result.subscribe(data => this.router.navigate(['/painel', 'fichas', 'observacoes']),
      error => {
        this.enviando = false;
        this.func.showErro(error.json());
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/observacoes-fichas/observacoes-fichas-form.component.ts